export default __webpack_public_path__ + "static/media/oriane-pic.0bef9625.jpg";